const state = {
  countries: {},
  states: {},
  cities: {},
}

const mutations = {
  UPDATE_COUNTRIES(state, countries) {
    state.countries = countries
  },
  UPDATE_STATES(state, states) {
    state.states = states
  },
  UPDATE_CITIES(state, cities) {
    state.cities = cities
  },
}

const actions = {
  updateCountries({
    commit
  }, address1) {
    commit('UPDATE_COUNTRIES', address1);
  },
  updateStates({
    commit
  }, address2) {
    commit('UPDATE_STATES', address2);
  },
  updateCities({
    commit
  }, address3) {
    commit('UPDATE_CITIES', address3);
  },
}

const getters = {
  Countries: state => {
    return state.countries
  },
  States: state => {
    return state.states
  },
  Cities: state => {
    return state.cities
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
